
import { Component, Vue } from 'vue-property-decorator'

import { Company } from '@/types/Company'
import companyModule from '@/store/company'
import CompanyEditor from '@/components/company/CompanyEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'CompanyList',
  components: {
    CompanyEditor,
    ContentList
  }
})
class CompanyList extends Vue {
  private listType = ListType

  private get storeModule() {
    return companyModule
  }

  private get companies(): Partial<Company>[] {
    return companyModule.companies
  }

  private get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Firmenname', value: 'legalName' },
      { text: 'Typ', value: 'type' },
      { text: 'Status', value: 'active' },
      { text: 'Eingeladen', value: 'invitedPartners' },
      { text: 'Registriert', value: 'acceptedPartners' },
      { text: 'gesamt', value: 'totalPartners' }
    ]
  }

  private get filters(): string[] {
    return ['type', 'active']
  }

  private setCompany(payload: Company) {
    companyModule.setCompany(payload)
    this.$router.push({ name: 'CompanyDetail', params: { cid: payload._id } })
  }
}

export default CompanyList
